import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.9267 18.1793C20.9267 18.1793 20.6747 17.225 20.6747 17.216C20.4046 16.1716 20.3416 15.0732 20.6296 14.0289C20.9807 12.7414 21.0347 11.3459 20.7197 9.89643C19.8915 6.07008 16.3718 3 11.961 3C6.59599 3 2.33821 7.61862 3.08535 13.0115C3.66145 17.189 7.38814 20.5652 11.961 20.5652C12.6429 20.5652 13.0428 20.503 13.4303 20.4427C13.7948 20.3861 14.1484 20.3311 14.7155 20.3311C16.1198 20.3311 18.1182 20.9253 18.1182 20.9253C19.8105 21.3575 21.3588 19.8449 20.9267 18.1793Z'
            />
        </SvgIcon>
    );
});
